<template>
  <section
    style="position: relative; overflow: hidden"
    :style="{ height: isMobile ? '400px' : '500px' }"
  >
    <v-img
      :src="indicatorBackgroundImage"
      style="position:absolute;top:0; width: 100%; height: 100%"
      gradient="to top right, rgba(12,28,38,.76), rgba(25,53,71,.4)"
    ></v-img>
    <v-card flat color="transparent pl-4 pl-md-12 pt-12">
      <p class="display-1 white--text font-weight-bold pt-4 pb-4">
        Indicadores Generales
      </p>
    </v-card>
    <v-row class="pl-10 pr-10 mx-auto">
      <v-col cols="4">
        <v-card
          flat
          color="transparent"
          class="d-flex flex-column align-center"
        >
          <SvgIcon
            icon="cp-outlined-diver-2"
            fill="#c0e2e6"
            :height="imageHeight"
          ></SvgIcon>
          <p
            class="ma-0 mt-4 headline text-center custom-text-color font-weight-bold"
          >
            {{ data.eventTotal || "..." }}
          </p>
          <p class="ma-0 body-1 text-center custom-text-color">buceos</p>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card
          flat
          color="transparent"
          class="d-flex flex-column align-center"
        >
          <SvgIcon
            icon="cp-outlined-fish-1"
            fill="#c0e2e6"
            :height="imageHeight"
          ></SvgIcon>
          <p
            class="ma-0 mt-4 headline text-center custom-text-color font-weight-bold"
          >
            {{ data.organismTotal || "..." }}
          </p>
          <p class="ma-0 body-1 text-center custom-text-color">Especies</p>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card
          flat
          color="transparent"
          class="d-flex flex-column align-center"
        >
          <div
            style="border: 2px solid #c0e2e6; border-radius: 50%; color: #c0e2e6"
            :style="{
              height: isMobile ? '72px' : '132px',
              width: isMobile ? '72px' : '132px'
            }"
            class="d-flex align-center font-weight-bold justify-center text-center line-clamp-1"
          >
            {{
              (
                (data.organismMostOccurrences || {}).vernacularName || "..."
              ).substring(0, 10)
            }}
          </div>
          <p class="ma-0 mt-6 body-1 text-center custom-text-color">Especie</p>
          <p class="ma-0 body-1 text-center font-weight-bold custom-text-color">
            más registrada
          </p>
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import SvgIcon from "@/components/SvgIcon";
export default {
  data: () => ({
    data: {},
    indicatorBackgroundImage: require("@/assets/home/indicatorBackgroundImage.jpg")
  }),
  components: { SvgIcon },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "70px";
        default:
          return "140px";
      }
    }
  },
  async mounted() {
    try {
      let { data } = await this.$http.get("home/get-indicators");
      this.data = data;
    } catch (err) {
      this.data = {};
    }
  }
};
</script>

<style>
.custom-text-color {
  color: #c0e2e6;
}
</style>
